<ol class="breadcrumb mb-0" *ngIf="breadCrumbs">
  
  <li *ngFor="let breadcrumb of breadCrumbs"
      class="breadcrumb-item">
    <a [class.pointer]="ifNotLast(breadcrumb) && breadcrumb['clickable']" (click)="(ifNotLast(breadcrumb) && breadcrumb['clickable'])?navigate(breadcrumb):false">
      {{ breadcrumb.label }}
    </a>
  </li>
</ol>